import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href="https://checkout.ketoairfryerarg.com/cart/48581633605861:1" onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${`block w-full md:w-auto text-center bg-[#00A86B] text-white font-heading font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_4px_14px_0_rgba(0,168,107,0.39)] hover:shadow-[0_6px_20px_rgba(0,168,107,0.23)] hover:bg-[#00965f] transition-all duration-200 ${className}`} pt-[10px] pb-[10px] mt-[30px] mb-[30px]`} data-id="element-59">
      {children}
    </motion.a>;
}